import { Icon, IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react'
import { Book } from 'lucide-react'

interface Props extends Omit<IconButtonProps, 'aria-label'> {}

const Component = ({ isLoading, onClick, ...props }: Props) => {
  return (
    <Tooltip label="Nova regra">
      <IconButton
        colorScheme="primary"
        aria-label="Adicionar"
        isLoading={isLoading}
        onClick={onClick}
        icon={<Icon as={Book} />}
        {...props}
      />
    </Tooltip>
  )
}

export default Component
